"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let TeamJoinedModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.comment = "";
    this.status = "";
    this.team_name = "";
    this.team_id = "";
    this.team_choose = false;
    this.vd_count = 0;
    this.shop_count = 0;
    this.account_no = "";
    this.user_name = "";
    this.audit_time = 0;
  }
};
TeamJoinedModel.model = "model.team";
TeamJoinedModel = __decorateClass([
  Annotation.ModelMeta
], TeamJoinedModel);
